import ServerSettings, {ServerSettingsFieldType} from "../../../../gd/settings/server-settings/server-settings"
import CrmContactSettings from "./crm-contact-settings"

const fieldsConfig = {

    'crmContactSettings': {
        type            : ServerSettingsFieldType.CLASS,
        class           : CrmContactSettings,
        defaultValue    : {}
    }

}

/**
 * The company's CRM settings - gd.company.settings.crm
 */
export default class CrmSettings extends ServerSettings {

    public crmContactSettings   : CrmContactSettings

    constructor(config: any) {

        super(config, fieldsConfig)

        this.crmContactSettings = this.initValue('crmContactSettings')
    }

    toJSON() {
        const result = {}

        this.valueToJson(result, 'crmContactSettings')

        return result
    }
}
